import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
      @for (item of model; track item; let i = $index) {
        @if (!item.separator) {
          <li
            app-menuitem
            [item]="item"
            [index]="i"
            [root]="true"
          ></li>
        }
        @if (item.separator) {
          <li class="menu-separator"></li>
        }
      }
    </ul>`,
})
export class AppMenu {
  model: any[] = [];

  ngOnInit() {
    this.model = [
      {
        label: 'Orders',
        icon: 'fa-solid fa-fw fa-inbox',
        items: [
          {
            label: 'Live Orders',
            icon: 'fa-solid fa-fw fa-list-check',
            routerLink: ['/orders/live'],
          },
          {
            label: 'Order History',
            icon: 'fa-solid fa-fw fa-clock-rotate-left',
            routerLink: ['/orders/history'],
          },
        ],
      },
      {
        label: 'Menu Management',
        icon: 'fa-solid fa-fw fa-utensils',
        items: [
          {
            label: 'Menu Builder',
            icon: 'fa-solid fa-fw fa-pen-to-square',
            routerLink: ['/menu'],
          },
          {
            label: 'Menu Tags',
            icon: 'fa-solid fa-fw fa-tag',
            routerLink: ['/menu/tags'],
          },
          {
            label: 'Menu Modifiers',
            icon: 'fa-solid fa-fw fa-list-ul',
            routerLink: ['/menu/modifiers'],
          },
          {
            label: 'Discounts & Specials',
            icon: 'fa-solid fa-fw fa-tags',
            routerLink: ['/menu/specials'],
          },
        ],
      },
      {
        label: 'Reports',
        icon: 'fa-solid fa-fw fa-chart-column',
        items: [
          {
            label: 'Sales Overview',
            icon: 'fa-solid fa-fw fa-chart-line',
            routerLink: ['/reports/overview'],
          },
          {
            label: 'Sales by Time',
            icon: 'fa-solid fa-fw fa-clock',
            routerLink: ['/reports/sales-time'],
          },
          {
            label: 'Top Items & Categories',
            icon: 'fa-solid fa-fw fa-ranking-star',
            routerLink: ['/reports/top-items'],
          },
          {
            label: 'Modifier Attach Rate',
            icon: 'fa-solid fa-fw fa-link',
            routerLink: ['/reports/modifiers'],
          },
          {
            label: 'Fulfillment Speed',
            icon: 'fa-solid fa-fw fa-stopwatch-20',
            routerLink: ['/reports/fulfillment'],
          },
          {
            label: 'Cancellations & Refunds',
            icon: 'fa-solid fa-fw fa-ban',
            routerLink: ['/reports/cancellations'],
          },
          {
            label: 'Orders by Location',
            icon: 'fa-solid fa-fw fa-map-location-dot',
            routerLink: ['/reports/locations'],
          },
        ],
      },
      {
        label: 'Course',
        icon: 'fa-solid fa-fw fa-flag',
        items: [
          {
            label: 'Course Settings',
            icon: 'fa-solid fa-fw fa-gear',
            routerLink: ['/courses'],
          },
          // {
          //     label: 'Payment Setup',
          //     icon: 'fa-solid fa-fw fa-credit-card',
          //     routerLink: ['/courses/payment'],
          // },
        ],
      },
      {
        label: 'User Management',
        icon: 'fa-solid fa-fw fa-users',
        items: [
          {
            label: 'Admin Users',
            icon: 'fa-solid fa-fw fa-user-gear',
            routerLink: ['/users'],
          },
        ],
      },
      // {
      //     label: 'Notifications',
      //     icon: 'fa-solid fa-fw fa-bell',
      //     items: [
      //         {
      //             label: 'Manage Notifications',
      //             icon: 'fa-solid fa-fw fa-sliders',
      //             routerLink: ['/notifications'],
      //         },
      //     ],
      // },
      {
        label: 'Settings',
        icon: 'fa-solid fa-fw fa-screwdriver-wrench',
        items: [
          // {
          //     label: 'Organization Settings',
          //     icon: 'fa-solid fa-fw fa-building',
          //     routerLink: ['/settings/organization'],
          // },
          {
            label: 'Profile',
            icon: 'fa-solid fa-fw fa-id-card',
            routerLink: ['/settings/profile'],
          },
          {
            label: 'Payment Settings',
            icon: 'fa-solid fa-fw fa-credit-card',
            routerLink: ['/settings/payment'],
          },
        ],
      },
    ];
  }
}
